<ion-app>
  <app-tabs-menu></app-tabs-menu>
</ion-app>
